import { render } from "./DisciplineOption.vue?vue&type=template&id=85e5913c&scoped=true&ts=true"
import script from "./DisciplineOption.ts?vue&type=script&lang=ts&external"
export * from "./DisciplineOption.ts?vue&type=script&lang=ts&external"

import "./DisciplineOption.scss?vue&type=style&index=0&id=85e5913c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e5913c"]])

export default __exports__